import _str from "shared/util/_str";

// Export each constant individually with "export NAME = value;"
export const ERRORS = {
	NO_ALBUMS: "NO_ALBUMS",
	NO_PHOTOS: "NO_PHOTOS",
};

export const DRAGGABLES = {
	PHOTO: "photo",
};

export const MIN_PHOTO_SIZE = 400;

export const RETURNING_ANIMATION_TIME = 150;
export const SORTING_ANIMATION_TIME = 200;

// this should be the same as $scale-preview in photo organizer's variables.scss
export const PREVIEW_SCALE = 0.7;

export const LAYOUTS = {
	HERO: "hero",
	TWOBYTHREE: "twobythree",
	THREEBYTWO: "threebytwo",
};

export const TOTAL_PHOTO_COUNTS = {
	[LAYOUTS.HERO]: 9,
	[LAYOUTS.TWOBYTHREE]: 6,
	[LAYOUTS.THREEBYTWO]: 6,
};

export const UPLOAD_STYLE = {
	single: "single",
	multiple: "multiple",
};

export const ERROR_CLEAR_TIME = 7000;

export const SORT_BY = {
	date: "date",
	likes: "likes",
};

export const FEEDBACK_STATES = {
	none: "none",
	error: "error",
	adding: "adding",
	deleting: "deleting",
	reordering: "reordering",
	complete: "complete",
};

const primarySubtitle = _str("You must be in the photo");
const tooLowSubtitle = _str("Upload more, you can get more likes");

export const FEEDBACK_TEXT = {
	start: [
		{
			title: _str("Add photos of you"),
			subtitle: primarySubtitle,
		},
	],

	[FEEDBACK_STATES.adding]: [
		{
			title: _str("Nice way to start."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Hubba hubba."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("That’s a good one."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Yes yes yes yes yes."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Killin’ it."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Love it."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Look at you, hot stuff."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("They’re going to love you."),
			subtitle: primarySubtitle,
		},
	],

	[FEEDBACK_STATES.deleting]: [
		{
			title: _str("Peace out, photo."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Au revoir!"),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Bye bye!"),
			subtitle: primarySubtitle,
		},
		{
			title: _str("Some don’t make the cut."),
			subtitle: primarySubtitle,
		},
		{
			title: _str("People love these -— add more"),
			subtitle: primarySubtitle,
		},
		{
			title: _str("There’s gotta be more!"),
			subtitle: primarySubtitle,
		},
	],

	[FEEDBACK_STATES.complete]: [
		{
			title: _str("Great job!"),
			subtitle: _str("You can add even more photos later!"),
		},
	],

	tooLow: [
		{
			title: _str("The more, the better"),
			subtitle: tooLowSubtitle,
		},
		{
			title: _str("Only one? Get a few more."),
			subtitle: tooLowSubtitle,
		},
		{
			title: _str("Fill this grid out!"),
			subtitle: tooLowSubtitle,
		},
		{
			title: _str("More photos, better matches."),
			subtitle: tooLowSubtitle,
		},
	],
};



// WEBPACK FOOTER //
// ./src/apps/photo_organizer/util/constants.js